import React from 'react'

const parseOptionalCap = (raw: string): number | null => {
  if (raw === '') return null
  return parseInt(raw, 10)
}

export const PricingConfig = ({ config, setConfig }) => {
  return (
    <div className="tenant-config">
      <div className="row mt-3 g-3">
        <div className="form-group col-12 col-md-6">
          <label className="form-label" htmlFor="roofCostCap">
            Maximum Roof % of Project Cost
          </label>
          <div className="input-group">
            <input
              id="roofCostCap"
              type="number"
              className="form-control"
              value={config.roofCostCap ?? ''}
              onChange={ev => setConfig({
                ...config,
                roofCostCap: parseOptionalCap(ev.target.value),
              })}
            />
            <span className="input-group-text">%</span>
          </div>
        </div>
        <div className="form-group col-12 col-md-6">
          <label className="form-label" htmlFor="storageCostCap">
            Maximum Storage % of Solar Cost
          </label>
          <div className="input-group">
            <input
              id="storageCostCap"
              type="number"
              className="form-control"
              value={config.storageCostCap ?? ''}
              onChange={ev => setConfig({
                ...config,
                storageCostCap: parseOptionalCap(ev.target.value),
              })}
            />
            <span className="input-group-text">%</span>
          </div>
        </div>
        <div className="form-group col-12 col-md-6">
          <label className="form-label" htmlFor="hvacCostCap">
            Maximum HVAC % of Project Cost
          </label>
          <div className="input-group">
            <input
              id="hvacCostCap"
              type="number"
              className="form-control"
              value={config.hvacCostCap ?? ''}
              onChange={ev => setConfig({
                ...config,
                hvacCostCap: parseOptionalCap(ev.target.value),
              })}
            />
            <span className="input-group-text">%</span>
          </div>
        </div>
        <div className="form-group col-12 col-md-6">
          <label className="form-label" htmlFor="batteryCostCap">
            Maximum Battery Price per kWh
          </label>
          <div className="input-group">
            <input
              id="batteryCostCap"
              type="number"
              className="form-control"
              value={config.batteryCostCap ?? ''}
              onChange={ev => setConfig({
                ...config,
                batteryCostCap: parseOptionalCap(ev.target.value),
              })}
            />
            <span className="input-group-text">$</span>
          </div>
        </div>
      </div>
    </div>
  )
}
